import axios from 'axios';

// API 基础 URL
const API_BASE_URL = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:5001/api' : '/api';

// 创建 axios 实例
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器，添加 token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 认证相关 API
export const authAPI = {
  login: (data) => api.post('/auth/login', data),
  register: (data) => api.post('/auth/register', data),
  refresh: (data) => api.post('/auth/refresh', data),
  logout: () => api.post('/auth/logout')
};

// 用户相关 API
export const userAPI = {
  getUsers: () => api.get('/users'),
  getUser: (id) => api.get(`/users/${id}`),
  updateUser: (id, data) => api.put(`/users/${id}`, data),
  deleteUser: (id) => api.delete(`/users/${id}`),
  getRoles: () => api.get('/users/roles')
};

// 流程相关 API
export const processAPI = {
  getProcesses: (params) => api.get('/processes', { params }),
  createProcess: (data) => api.post('/processes', data),
  getProcess: (id) => api.get(`/processes/${id}`),
  updateProcess: (id, data) => api.put(`/processes/${id}`, data),
  deleteProcess: (id) => api.delete(`/processes/${id}`),
  getProcessStages: (id) => api.get(`/processes/${id}/stages`),
  saveStageUsers: (stageId, userIds) => api.post(`/processes/stage/${stageId}/users`, { user_ids: userIds }),
  saveStageContent: (stageId, content, createdBy) => api.post(`/processes/stage/${stageId}/content`, { content, created_by: createdBy }),
  completeStageUser: (stageUserId) => api.post(`/processes/stage-user/${stageUserId}/complete`)
};

// 任务相关 API
export const taskAPI = {
  getTasks: () => api.get('/tasks'),
  getTask: (id) => api.get(`/tasks/${id}`),
  getTaskAssignments: (id) => api.get(`/tasks/${id}/assignments`),
  completeTask: (id, data) => api.post(`/tasks/${id}/complete`, data)
};

// 内容相关 API
export const contentAPI = {
  createContent: (data) => api.post('/contents', data),
  getContent: (id) => api.get(`/contents/${id}`),
  updateContent: (id, data) => api.put(`/contents/${id}`, data),
  uploadImage: (formData) => api.post('/contents/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
};

export default api;
